module.exports = __webpack_public_path__ + "static/media/landscape_play_btn.08707114.png";